// extracted by mini-css-extract-plugin
module.exports = {"twitterEmbed":"style_twitterEmbed__Cq7rt","fallback":"style_fallback__zWm_H g-grid-container"};